/* istanbul ignore file */
/**
 * Class for set & get view-port attributes
 */
var Viewport = /** @class */ (function () {
    function Viewport() {
    }
    /**
     * get scale of view-port
     */
    Viewport.getScale = function () {
        var viewPort = document.querySelector('meta[name=viewport]');
        var scale = 1;
        if (viewPort) {
            var viewPortContent = viewPort.getAttribute('content');
            var getParam = function (name, str) {
                var reg = new RegExp("(^|,)" + name + "=([^,]*)(,|$)", 'i'); //定义正则表达式
                var r = str.match(reg);
                if (r != null)
                    return r[2];
                return null;
            };
            var initialScale = +(getParam('initial-scale', viewPortContent) || 1);
            var maximumScale = +(getParam('maximum-scale', viewPortContent) || 1);
            var minimumScale = +(getParam('minimum-scale', viewPortContent) || 1);
            scale = Math.min(initialScale, maximumScale, minimumScale);
        }
        return scale;
    };
    /**
     * set scale of view-port
     */
    Viewport.setScale = function (scale) {
        var viewPort = document.querySelector('meta[name=viewport]');
        if (!viewPort) {
            return;
        }
        var viewPortContent = viewPort.getAttribute('content');
        var viewPortContentParts = viewPortContent.split(',');
        var newViewPortContent = '';
        for (var i = 0, len = viewPortContentParts.length; i < len; i++) {
            var attr = viewPortContentParts[i];
            if (~attr.indexOf('initial-scale') || ~attr.indexOf('maximum-scale') || ~attr.indexOf('minimum-scale')) {
                continue;
            }
            else {
                newViewPortContent += attr + ",";
            }
        }
        newViewPortContent += "initial-scale=" + scale + ", maximum-scale=" + scale + ", minimum-scale=" + scale;
        viewPort.setAttribute('content', newViewPortContent);
    };
    return Viewport;
}());
export default Viewport;
